import React, { useState } from "react";
import PageShell from "../dashboard/PageShell";
import RichTextEditor from "../../components/forms/RichTextEditor";

interface ProductTypeIIFormData {
  productName: string;
  specifications: string;
  detailedContent: string;
}

const AddProductTypeII: React.FC = () => {
  const [formData, setFormData] = useState<ProductTypeIIFormData>({
    productName: "",
    specifications: "",
    detailedContent: "",
  });

  const handleInputChange = (
    field: keyof ProductTypeIIFormData,
    value: string
  ) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Saving product type II:", formData);
    // TODO: Implement save functionality
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <PageShell title="Thêm sản phẩm dạng II">
      <div className="space-y-6">
        {/* Header */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm sản phẩm dạng II
          </h1>
        </div>

        {/* Form Container */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-6">
            {/* Row 1: Tên sản phẩm - Thông số */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tên sản phẩm <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.productName}
                  onChange={(e) =>
                    handleInputChange("productName", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập tên sản phẩm..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Thông số <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.specifications}
                  onChange={(e) =>
                    handleInputChange("specifications", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập thông số..."
                />
              </div>
            </div>

            {/* Rich Text Editor Section */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nội dung - Thông số chi tiết sản phẩm
              </label>
              <RichTextEditor
                value={formData.detailedContent || ""}
                onChange={(value: string) =>
                  handleInputChange("detailedContent", value)
                }
                placeholder="Nhập nội dung thông số chi tiết sản phẩm..."
                height="large"
              />
            </div>
          </div>
        </div>

        {/* Form Actions */}
        <div className="flex justify-end gap-3">
          <button
            onClick={handleCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Hủy
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
          >
            Lưu
          </button>
        </div>
      </div>
    </PageShell>
  );
};

export default AddProductTypeII;
